export default "__VITE_ASSET__9zZuYWfB__"